import { createVNode as o, mergeProps as l } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MetadataFilled.js";
import d from "../components/PfIcon.js";
const t = (e, a) => {
  const r = {
    ...e,
    ...a.attrs
  };
  return o(d, l(r, {
    icon: i
  }), null);
};
t.displayName = "MetadataFilled";
t.inheritAttrs = !1;
export {
  t as default
};
